// https://atomiks.github.io/tippyjs/
import tippy from 'tippy.js';

const tooltips = document.querySelectorAll('.js-tooltip')

tooltips.forEach((el) => {
  const tooltipContentHTML = document.querySelector(el.getAttribute('data-tooltip-html'))
  const tooltipContent = tooltipContentHTML ? tooltipContentHTML : el.getAttribute('data-tooltip');

  tippy(el, {
    content: tooltipContent,
    allowHTML: true,
  });
})
